// extracted by mini-css-extract-plugin
module.exports = {"rights":"dokument_rights__LHscv","cards":"dokument_cards__kDX5t","praxisCards":"dokument_praxisCards__aHLal"};